import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import CheckIcon from 'mdi-react/CheckIcon';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

class TrustedCard extends React.Component {
  static propTypes = {
    item: PropTypes.shape({}).isRequired,
    openUserInfo: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      isAccepted: false,
    };
  }

  acceptTerms = (event) => {
    this.setState({
      isAccepted: event.target.checked,
    });
  }

  render() {
    const { item, openUserInfo } = this.props;
    const { isAccepted } = this.state;

    return (
      <div key={item._id} className="trusted-card">
        <Row>
          <Col>
            <div>
              <h4 className="fw-500">
                {item.given_name} {item.family_name}
              </h4>
              <p className="mt-0">Né{item.gender === 'female' && 'e'} le {moment(item.birthdate).format('L')} à {item.birth_city ? item.birth_city : '[ Non précisé ]'}</p>
            </div>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button disabled={!isAccepted} className="mb-0" onClick={() => openUserInfo(item)}>
              Voir ses informations
            </Button>
          </Col>
        </Row>
        <label className="mt-20 checkbox-btn checkbox-btn--colored-click" htmlFor={item._id}>
          <input
            className="checkbox-btn__checkbox"
            type="checkbox"
            id={item._id}
            name="isAccepted"
            onChange={this.acceptTerms}
          />
          <span className="checkbox-btn__checkbox-custom">
            <CheckIcon />
          </span>
          <span className="checkbox-btn__label">
            En cochant cette case, vous certifiez sur l'honneur être le notaire en charge de sa succession.
            {/* <br />A des fins de registre et d'historique, chaque recherche est enregistrée. */}
          </span>
        </label>
      </div>
    );
  }
}

export default TrustedCard;
